import React from 'react';

function DancePopModalBody() {
  return (
    <p>
      1980년대 디스코의 인기 하락 이후 디스코 음악 요소를 개량해 파생된 새로운
      형태의 음악이며 댄스와 팝이 결합된 장르이다.
      <br />
      주로 업 템포 음악으로, 춤추기에 적합하며 흥겹고 강렬한 리듬감과 긍정적
      에너지를 담은 중독성 있는 멜로디가 특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Lady Gaga, Dua Lipa, Calvin Harris
      </p>
    </p>
  );
}

function ElecPopModalBody() {
  return (
    <p>
      1970년대 후반 전자적인 기기들의 도입으로 신스팝(Synthpop)과 거의 동시대에
      등장한 전자 음악 장르의 한 갈래이며 이후 하우스나 테크노 등 많은 영향을
      끼친 장르이다.
      <br />
      순수 악기와 보컬의 범주에서 벗어나 다채로운 기계적인 사운드, 신디사이저,
      드럼 머신을 결합한 것이 특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Halsey, Sia, LMFAO
      </p>
    </p>
  );
}

function BritPopModalBody() {
  return (
    <p>
      대한민국의 대중가요를 뜻하며 "Korean Popular Music"을 줄여서 K- POP 이란
      용어가 탄생하였다. 한국 아이돌만이 해당 되는것이 아닌 어떤 장르이든 간
      한국의 엔터테이먼트에서 만들어진 대중적인 음악들을 케이팝이라고 부를수
      있다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트: BTS, Black Pink, New Jeans
      </p>
    </p>
  );
}

function IndiPopModalBody() {
  return (
    <p>
      먼저 "인디"는 "독립"을 뜻하며, 이 장르는 주로 대중성을 갖추면서도 음악
      산업에서 독립적으로 활동하는 아티스트와 밴드를 일컫는 말이다. 펑크 록(Punk
      Rock)의 DIY(Do it yourself) 정신과 이념에 영향을 받아 주류 팝,록 음악에
      대항하여 자급자족으로 음악을 만든다는 특징이 있다. 그래서 "인디"는 곧
      음악적 특징의 개념보단 아티스트의 제작 방식에 따른 분류의 따라 붙는다고 할
      수 있다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : The Smith, Omar Apollo, Men I Trust
      </p>
    </p>
  );
}

function LatinPopModalBody() {
  return (
    <p>
      라틴 아메리카의 음악 요소와 팝 음악이 결합된 장르이다. 라틴 팝은 주로
      스페인어, 포르투칼어를 사용하는 보컬이 다수지만 다른 언어권을 사용해도
      라틴 리듬이 첨가된 음악 또한 포함된다.
      <br />
      삼바, 메렝게, 레게톤, 쿠바노, 플라멩코 등 다양한 리듬이 사용되는 것이
      특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Camila Cabello, Shakira, Enrique Iglesias
      </p>
    </p>
  );
}

function LatinJazzModalBody() {
  return (
    <p>
      1940년대 라틴 아메리카 음악과 재즈음악의 만남으로 재즈의 형태 속 라틴
      아메리카의 클라베, 탱고, 살사, 삼바 등 특유한 리듬 패턴이 첨가됨 음악이다.
      대표적으로 아프로큐반 재즈(Afro-Cuban jazz)는 쿠바, 보사노바(Bossa nova)는
      브라질 곧 라틴아메라카의 속한 나라에서 탄생했으며 특히 퍼커션 악기의
      사운드가 두드러지는 것이 특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Paquito D'Rivera, Arturo Sandoval, Stan Getz
      </p>
    </p>
  );
}

function SwingJazzModalBody() {
  return (
    <p>
      1930년대 미국에서 발전한 재즈 스타일이며 셔플리듬과 비슷하나 미묘하게
      강세가 다르다. "Swing"음악은 마치 '그루브'라는 표현처럼 본능적으로 발을
      두드리거나 머리를 끄덕이게 만드는게 중요하다. 1930~40년대에는 스윙댄스가
      유행했으며 리듬을 느끼며 춤추기에 적합한 것이 특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Benny Goodman, Count Basie, Duke Ellington
      </p>
    </p>
  );
}

function SoulJazzModalBody() {
  return (
    <p>
      1950년대 흑인만의 풍부한 펑키(Funky)한 소울과 재즈가 결합된 음악이다. 펑키
      재즈(Funky jazz)라고도 부를 수 있으며 하드 밥(Hard Bop)의 파생물이자 흑인
      음악인 블루스(Blues), 소울(Soul), 가스펠(Gaspel)의 강한 영향을 받은것이
      특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Robert Glasper, The Ramsey Lewis Trio, Angie Stone
      </p>
    </p>
  );
}

function FreeJazzModalBody() {
  return (
    <p>
      1960년대 중반 기존 재즈구조와 규칙에 매너리즘에 빠져 탄생한 창작적 자유가
      담긴 즉흥 스타일의 재즈이며 아방가르드 재즈(Avant-garade jazz) 라고도
      부른다. 정통을 무시한 채 구조화된 조성, 박자에 구애받지 않는 것이
      특징이다. 또한 당시 흑인인권차별에 대한 "Free"를 외치는 정치적 의미가 담겨
      있다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트: Ornette Coleman, John Coltrane, Cecil Taylor
      </p>
    </p>
  );
}

function BibobJazzModalBody() {
  return (
    <p>
      1940년대 초중반 스윙재즈에 대항하여 발전한 재즈 스타일로 빠른 템포,
      역동적인 코드 변경, 수많은 조 변경, 당김음을 포함시킨 음악이다. 악기별
      창의적인 솔로 연주와 악기의 화려한 기교가 들어간다는 것이 특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Charlie Parker, Dizzy Gillespie, Bud Powell
      </p>
    </p>
  );
}

function DrillHipModalBody() {
  return (
    <p>
      2010년대 초반에 시카고에 트랩(Trap) 아티스트들이 발전시킨 음악이며
      '누군가를 쏘다'의 속어인 "Drill"은 트랩보다 훨씬 폭력적이고 전투적인
      가사와 주로 범죄와 관련된 잔혹한 삶을 음악에 담는다. 2010년대 후반부터는
      유럽 전역에서 유행이 시작돼 "UK Drill" 이 탄생한다. UK드릴은 그라임(Grime)
      , 개러지(UK Garage)의 영향을 받았으며 빠른 bpm, 단조의 어두운 분위기,
      트레실로(Tresillo) 하이햇 패턴, 글라이딩 기술의 808베이스 등이 특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Chief Keef, Pop Smoke, Central Cee
      </p>
    </p>
  );
}

function TrapHipModalBody() {
  return (
    <p>
      1990년대 등장하여 마약을 제조 판매하던 "Trap house"에서 이름이 탄생했다.
      그래서 모든 아티스트가 그런 것은 아니지만 대부분 약물, 도시폭력, 성 관련된
      가사를 직접적으로 표출한다. 또한 신디사이저 드럼에 빠르고 복잡한 하이햇
      패턴이 특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Future, Migos, Gucci Mane
      </p>
    </p>
  );
}

function AlterHipModalBody() {
  return (
    <p>
      1980년대 초 얼터너티브 록(Alternative rock)과 비슷한 시기에 시작됐다고 볼
      수 있다. "얼터너티브(Alternative)" 뜻처럼 대안적인 음악이며 기존
      힙합장르의 뼈대에서 여러 부분을 실험적인 사운드로 채워 아티스트마다 특색이
      보다 더욱 드러나는 것이 특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Kanye West(Ye), Tyler, The Creator, Kid Cudi
      </p>
    </p>
  );
}

function RageHipModalBody() {
  return (
    <p>
      2021년 Trippie Redd라는 아티스트 트랙인 "Miss the Rage"에서 이름을 따왔다.
      "Trap(트랩)"의 하위장르지만 "Hyper pop(하이퍼 팝)"과 밀접한 장르이기에
      에너지가 느껴지는 신디사이저와 분노를 표출하는 듯한 가사가 특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Playboi Carti, Trppie Redd, lil Uzi Vert
      </p>
    </p>
  );
}

function BoomHipModalBody() {
  return (
    <p>
      1990년대 힙합 전성기 시절 동부 힙합(East Coast hip hop)에서 두드러진
      장르이자 음악 제작 스타일이다. 드럼소리를 의성어로 표현해 '붐 뱁 붐붐 뱁
      붐' 같은 드럼의 소리에서 따온 것이다. 그만큼 드럼의 그루브와 역할의 비중이
      큰 음악이다. 대부분 느긋하고 단조로운 드럼의 그루브를 느낄 수 있으며
      올드한 질감의 샘플링을 사용하는 것이 특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Wu-Tang Clan, Jay-Z, Nas
      </p>
    </p>
  );
}

function ProRockModalBody() {
  return (
    <p>
      1960년대 등장한 음악 장르이며 클래식 음악, 재즈, 포크 등 많은 문화적,
      음악적 요소를 결합한 장르이다. 가사는 시적이고 철학적인 요소가 담겨 있으며
      전반적으로 곡이 복잡하고 긴 진행 구조이다. 그래서 다양한 악기의 연주와 긴
      솔로가 특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Yes, Rush, King Crimson
      </p>
    </p>
  );
}

function HeavyRockModalBody() {
  return (
    <p>
      1960년대 후반 하드록(Hard rock), 블루스 록(Blues rock)장르의 아티스트들이
      발전시킨 장르이다. 장르 이름에서 느껴지는 그대로 빠른템포와 강력하고
      찢어지는 듯한 높은 음량, 복잡한 기타 리프, 강렬한 드럼 비트, 보컬의
      샤우팅이 특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Led Zeppelin, Metallica, Guns N' Roses
      </p>
    </p>
  );
}

function AlterRockModalBody() {
  return (
    <p>
      1960년대 등장해 포스트 펑크(Post Punk)의 DIY(Do it yourself)정신의 영향을
      받아 전통적이고 대중화된 록 사운드의 "대안"(Alternative) 으로 만들어진
      장르이다. 기존 록만의 구성 방식을 실험적으로 바꿔 많은 하위장르를 탄생시킨
      것이 특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Nirvana, Coldplay, Pearl Jam - J
      </p>
    </p>
  );
}

function PunkRockModalBody() {
  return (
    <p>
      1970년대 등장한 펑크 록은 문화 운동으로 시작되었다. "DIY(Do It Yourself)"
      정신과 이념의 시발점이다. 그래서 펑크 운동의 원칙 중 하나로 빠르고 간결한
      곡 구조와 사회 문제에 대한 직설적인 가사전달이 특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Sex Pistols, Green Day, The Clash
      </p>
    </p>
  );
}

function ShowRockModalBody() {
  return (
    <p>
      1980년대 말 영국에서 등장했으며 Shoe(신발) + gaze(응시하다)의 합성어로
      관객과의 소통없이 기타 이펙트 페달을 밟는 발만 내내 내려다보며 연주한다는
      이유로 이와 같은 이름이 탄생했다. 강한 리벌브와 딜레이 효과가 걸려있어
      환상속에 있는 듯한 장황한 기타리프가 특징이다. 그리고 보컬의 뭉게지는 듯한
      사운드와 여운이 느껴지는 멜로디와 가사가 특징이다. 때론 "Dream
      pop"이라고도 불린다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Slow Dive, Cocteau Twins, Beach House
      </p>
    </p>
  );
}

function NeoRbModalBody() {
  return (
    <p>
      1990년대 전통적인 소울과 R&B의 요소를 현대적으로 재해석해 생겨난 음악
      양식을 홍보 및 설명하고자 만들어진 용어이다. 많은 장르에 걸쳐 다양한
      요소가 합해져 있으며 좀 더 소울스러운 흑인만의 색감이 나타나는것이
      특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : D'Angelo, Erykah Badu, Maxwell
      </p>
    </p>
  );
}

function ComtemRbModalBody() {
  return (
    <p>
      1980년대 미국에서 대중화됐으며 이전에 있던 전통 R&B와 구분하기 위해
      만들어진 이름이다. 기존의 R&B의 틀에서 다른 많은 장르를 융합시켜 시간의
      흐름에 따라 다양한 변주가 있는 장르이다. 거기에 현대적인 프로덕션 기술과
      뛰어난 보컬의 조화로 풍성하고 세련된 사운드가 특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : SZA, Beyoncé, Usher
      </p>
    </p>
  );
}

function PunkRbModalBody() {
  return (
    <p>
      펑크는 1960년대 중반 아프리카계 미국인들 사이에서 유행했으며 '강한 냄새'
      곧 신체적 노력으로 인한 체취가 느껴지는 음악이라는 뜻이다. 다양한 음악
      장르를 혼합해 끈적한 그루브와 리듬이 강조된 음악이라 그루브를 느끼며
      춤추기 쉬운 새로운 형태의 리듬적 역할이 강한 음악이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : James Brown, King Floyd, Sly and the Family Stone
      </p>
    </p>
  );
}

function SoulRbModalBody() {
  return (
    <p>
      1950년대 후반 민권운동의 시작으로 등장했고 블루스(Blues)의 정신과
      가스펠(Gaspel)의 영향이 더해져 R&B(알앤비)의 뿌리가 되는 음악이다. 당시
      백인들만의 음악은 로큰롤(Rock'n Rll)이었다면 흑인들만의 음악은
      소울(Soul)음악이었다. 그리고 아프리카계 미국인이 소유한 최초의 레코드
      레이블인 "모타운(Motown)"이 등장해 흑인 음악이 대중화가 되는데 큰 기여를
      했다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Stevie Wonder, Marvin Gaye, Sam Cooke
      </p>
    </p>
  );
}

function AlterRbModalBody() {
  return (
    <p>
      2000년대 중후반에 등장한 장르로 Progressvie R&B(프로그레시브 알앤비), PB
      R&B(피비 알앤비), Hipster R&B(힙스터 알앤비) 등으로 불리기도 해 유래와
      탄생이 명확하지 않다. EDM, 록, 힙합 등을 결합을 서슴지 않고 시도해
      실험적이고 변칙적인 사운드를 탄생시켜 귀를 매료시키는 음악이다. 대부분
      나긋한 멜로디 위에 신디사이저(Synth)를 활용한 몽환적인 사운드가 특징이다.
      <p style={{ fontSize: '14px' }}>
        <br />
        대표 아티스트 : Frank ocean, Steven lacy, dvsn
      </p>
    </p>
  );
}

export {
  DancePopModalBody,
  ElecPopModalBody,
  BritPopModalBody,
  IndiPopModalBody,
  LatinPopModalBody,
  LatinJazzModalBody,
  SwingJazzModalBody,
  SoulJazzModalBody,
  FreeJazzModalBody,
  BibobJazzModalBody,
  DrillHipModalBody,
  TrapHipModalBody,
  AlterHipModalBody,
  RageHipModalBody,
  BoomHipModalBody,
  ProRockModalBody,
  HeavyRockModalBody,
  AlterRockModalBody,
  PunkRockModalBody,
  ShowRockModalBody,
  NeoRbModalBody,
  ComtemRbModalBody,
  PunkRbModalBody,
  SoulRbModalBody,
  AlterRbModalBody,
};
